"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = TcombReactWidgetsComboBox;

var _react = require("react");

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var __assign = undefined && undefined.__assign || Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
    }
    return t;
};

var Combobox = require("react-widgets/lib/Combobox"); // only load the datetimepicker and nothin else, the whole react-widgets suite is too much.
var classnames = require("classnames");
// this is a tcomb form template --> https://gcanti.github.io/tcomb-form/guide/index.html#templates
// wraps the datetime picker from react widgets to use it within tcomb-form (through a tempalte function)
function TcombReactWidgetsComboBox(props) {
    var formGroupClasses = {
        "form-group": true,
        "has-feedback": true,
        "has-error": props.hasError
    };
    var config = Object.assign({
        reactWidgetConfig: {}
    }, props.config);
    return React.createElement("div", { className: classnames(formGroupClasses) }, props.label ? React.createElement("label", { className: "control-label" }, props.label) : null, React.createElement(Combobox, __assign({}, config.reactWidgetConfig, { value: props.value, onChange: function onChange(value) {
            props.onChange(value);
        } })), props.error ? React.createElement("span", { className: "help-block error-block" }, props.error) : null, props.help ? React.createElement("span", { className: "help-block" }, props.help) : null);
}
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/TcombReactWidgetsComboBox.tsx
 ** module id = 1305
 ** module chunks = 0
 **/